<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增档案"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="健康管理对象" prop="user_info">
                <el-autocomplete class="user_search"
                                 v-model="ruleForm.user_info"
                                 :fetch-suggestions="getUser"
                                 placeholder="请输入健康管理对象姓名"
                                 @select="userSelect"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item label="档案标题" prop="title">
                <el-input type="text" v-model="ruleForm.title" placeholder="请输入档案标题" autocomplete="off"
                          style="width: 100%;" maxlength="20"></el-input>
            </el-form-item>

            <!--          下拉选择-->
            <el-form-item label="健康管理专家姓名" prop="doctor_id">
                <el-select v-model="ruleForm.doctor_id" placeholder="请选择健康管理专家"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allUserDoctor"
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="诊断结果" prop="diagnosis">
                <el-input type="textarea" v-model="ruleForm.diagnosis" placeholder="请输入健康管理专家建议" autocomplete="off"
                          style="width: 100%;" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="处置方式" prop="dispose_type">
                <el-radio-group v-model="ruleForm.dispose_type" @change="typeChange">
                    <el-radio :label="1">用药</el-radio>
                    <el-radio :label="2">输液</el-radio>
                    <el-radio :label="3">留院观察</el-radio>
                    <el-radio :label="4">住院治疗</el-radio>
                    <el-radio :label="5">其他</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="" v-if="is_other_type">
                <el-input type="textarea" id="other_dispose_type" v-model="ruleForm.other_dispose_type" autosize maxlength="10"  placeholder="请输入其他处理方式(10字内)" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="健康管理专家建议" prop="describe">
                <el-input type="textarea" v-model="ruleForm.describe" placeholder="请输入健康管理专家建议" autocomplete="off"
                          style="width: 100%;" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="会面日期" prop="meet_date">
                <el-date-picker
                    v-model="ruleForm.meet_date"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="图片上传" :label-width="formLabelWidth">
                <el-upload
                    ref="upload"
                    class="upload-demo"
                    accept=".PNG,.JPG,.JPEG,.JPEG,.png,.jpg"
                    :action="upload_path"
                    :file-list="fileList"
                    :on-remove="handleRemove"
                    :on-success="handleSuccess"
                    :before-upload="beforeAvatarUpload"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">注：支持PNG,JGP文件格式</div>
                </el-upload>
            </el-form-item>


            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";

export default {
    created() {

    },
    mounted() {
        // this.createParams();
    },
    data() {
        return {
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            userAvaratImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            allUser: [],
            allUserDoctor: [],
            fileList: [],
            addFileList: [],
            formLabelWidth: '120px',
            is_other_type: false,
            ruleForm: {
                user_id: '',
                title: '',
                doctor_id: '',
                hospital_name: '',
                hospital_id: '',
                describe: '',
                consultation_department: '',
                doctor_department_id: '',
                dispose_type: 0,
                diagnosis: '',
                user_info: '',
                meet_date: '',
                other_dispose_type: '',
            },
            rules: {
                user_info: [
                    {required: true, message: "请选择健康管理对象", trigger: "blur"},
                ],
                title: [
                    {required: true, message: "请输入标题", trigger: "blur"},
                ],
                doctor_id: [
                    {required: true, message: "请选择健康管理专家", trigger: "blur"},
                ],
                describe: [
                    {required: true, message: "请输入健康管理专家建议", trigger: "blur"},
                ],
                diagnosis: [
                    {required: true, message: "请输入诊断结果", trigger: "blur"},
                ],
                dispose_type: [
                    {required: true, message: "请选择处置方式", trigger: "blur"},
                ],
                meet_date: [
                    {required: true, message: "请选择会面日期", trigger: "blur"},
                ],
            }

        };
    },
    methods: {
        // 返回上一页
        goBack() {
            // window.history.go(-1);
            window.close()
        },

        // 除去图片
        handleRemove(file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        addFileList.push(name);
                    }
                }
            }
            this.addFileList = addFileList;
        },
        typeChange(v) {
            if (v == 5) {
                this.is_other_type = true
                var timer = setInterval(function () {
                    let other_type = document.getElementById("other_dispose_type")
                    other_type.focus()
                    clearTimeout(timer)
                }, 100)
            } else {
                this.is_other_type = false
            }
        },
        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        addFileList.push(name);
                    }
                }
            }
            this.addFileList = addFileList;
        },

        // 提交表单
        submitForm(formName) {
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.ruleForm.dispose_type == 5 && !this.ruleForm.other_dispose_type) {
                        this.$message({
                            type: "error",
                            message: '请输入其他处理方式'
                        });
                        let other_type = document.getElementById("other_dispose_type")
                        other_type.focus()
                        return false;
                    }
                    let params = {
                        'servername': 'Ruyi_AdminCustomerServices',
                        'method': 'createUserHealthrecords',
                        'params': {
                            user_id: this.ruleForm.user_id,
                            title: this.ruleForm.title,
                            doctor_id: this.ruleForm.doctor_id,
                            doctor_department_id: this.ruleForm.doctor_department_id,
                            hospital_id: this.ruleForm.hospital_id,
                            describe: this.ruleForm.describe,
                            images: this.addFileList,
                            diagnosis: this.ruleForm.diagnosis,
                            dispose_type: this.ruleForm.dispose_type,
                            meet_date: this.ruleForm.meet_date,
                            other_dispose_type: this.ruleForm.other_dispose_type
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '创建成功',
                            duration: 1500,
                            onClose: function () {
                                // window.history.go(-1);
                                _that.$router.push({
                                    name: "healthrecordsList",
                                    params: {}
                                });
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    return false;
                }
            });
        },
        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },
        changeUser() {
            this.ruleForm.doctor_id = '';
            this.ruleForm.hospital_id = '';
            this.getAllDoctors();
        },
        getAllDoctors() {
            let params = {
                servername: 'Ruyi_AdminDoctorServices',
                method: 'getAllDoctorWithUser',
                params: {
                    user_id: this.ruleForm.user_id,
                }
            };
            this.allUserDoctor = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allUserDoctor = res.data.data;
            });
        },
        getUser(key, cb) {
            if (key.indexOf('/') > -1) {
                this.prev_search = key.split('/')[1] || key.split('/')[0]
                key = this.prev_search
            }
            if (!key || this.search_key == key) {
                this.search_key = '';
                cb([{"value": "请输入健康管理对象关键词"}]);
                return;
            }
            this.search_key = key
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'searchUser',
                params: {
                    user_name: key,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }
                // this.use_doctors = res.data.data
                var users = res.data.data
                if (!users) {
                    return cb([{"value": "没有找到健康管理对象"}]);
                }
                for (var i = 0; i < users.length; i++) {
                    users[i].value = users[i].user_name
                    users[i].value = users[i].short_name + '/' + users[i].user_name
                }
                cb(users);
            });

        },
        userSelect(item) {
            this.ruleForm.user_id = item.user_id;
            this.ruleForm.user_name = `${item.short_name}/${item.user_name}`;
            this.changeUser()
        },
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}

.user_search {
    text-align: left;
    width: 100%;
}
</style>
